import gql from 'graphql-tag';

export const setTrend360StatusMutation = gql`
    mutation setTrend360StatusMutation($id: ID!, $status: Status360!) {
        results: trend360SetStatus(id: $id, newStatus: $status) {
            id
            status
        }
    }
`;
